import { Suspense, Component } from 'react';

// project imports
import Loader from './Loader';

class ErrorHandlerBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  isChunkLoadError(error) {
    return error?.name === 'ChunkLoadError' || 
           error?.message?.includes('dynamically imported module') ||
           error?.message?.includes('Loading chunk') ||
           error?.message?.includes('Failed to fetch');
  }

  componentDidCatch(error, errorInfo) {
    console.error("Chunk/Component error caught:", error, errorInfo);
    
    if (this.isChunkLoadError(error)) {
      const lastReload = sessionStorage.getItem('chunk_load_reload');
      const now = Date.now();
      if (!lastReload || now - parseInt(lastReload, 10) > 4000) {
        sessionStorage.setItem('chunk_load_reload', String(now));
        window.location.reload();
      }
    }
  }

  render() {
    if (this.state.hasError) {
      const isChunkError = this.isChunkLoadError(this.state.error);

      if (isChunkError) {
        return (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '60vh', fontFamily: 'Poppins, sans-serif' }}>
            <Loader />
            <p style={{ marginTop: '16px', color: '#64748b', fontSize: '13px' }}>Loading latest version...</p>
          </div>
        );
      }
      return (
        <div style={{ padding: '32px', textAlign: 'center', fontFamily: 'Poppins, sans-serif' }}>
          <p style={{ color: '#64748b', fontSize: '14px', marginBottom: '12px' }}>An unexpected error occurred rendering this view.</p>
          {this.state.error && (
            <details style={{ maxWidth: '600px', margin: '0 auto 16px', textAlign: 'left', color: '#dc2626', fontSize: '12px' }}>
              <summary style={{ cursor: 'pointer', color: '#64748b', marginBottom: '8px' }}>Technical Details</summary>
              <pre style={{ background: '#fef2f2', padding: '12px', borderRadius: '6px', overflow: 'auto', border: '1px solid #fecaca', whiteSpace: 'pre-wrap' }}>
                {this.state.error?.stack || this.state.error?.message || String(this.state.error)}
              </pre>
            </details>
          )}
          <button 
            onClick={() => window.location.reload()} 
            style={{ padding: '8px 18px', background: 'linear-gradient(135deg, #14B8A6 0%, #0D9488 100%)', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 500, fontSize: '13px' }}
          >
            Refresh View
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function Loadable(Component) {
  const WrappedComponent = (props) => (
    <ErrorHandlerBoundary>
      <Suspense fallback={<Loader />}>
        <Component {...props} />
      </Suspense>
    </ErrorHandlerBoundary>
  );

  return WrappedComponent;
}
